module.exports = __webpack_public_path__ + "img/58_8.e6747326.png";